import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { BackButton } from './BackButton';

interface Props {
  title?: string;
  subtitle?: boolean;
  withBackBtn?: boolean;
}

export const PageHeaderSkeleton = ({ title, subtitle, withBackBtn }: Props) => {
  const theme = useTheme();

  return (
    <AppBar
      data-testid="header-skeleton"
      sx={{ borderBottom: '1px solid #eee', backgroundColor: 'white' }}
    >
      <Toolbar
        disableGutters
        sx={{
          height: 80
        }}
      >
        <Container
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            verticalAlign: 'middle'
          }}
        >
          {withBackBtn && <BackButton />}

          <Box
            sx={{
              display: 'flex',
              flexDirection: subtitle ? 'column' : 'row',
              alignItems: 'center',
              maxWidth: '80%'
            }}
          >
            {title ? (
              <Typography
                variant="h5"
                align="center"
                color={theme.palette.text.secondary}
                sx={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}
              >
                {title}
              </Typography>
            ) : (
              <Skeleton variant="text" width={100} height={40} />
            )}
            <Skeleton variant="text" width={150} height={20} />
          </Box>

          <Box sx={{ width: '40px', padding: '8px' }} />
        </Container>
      </Toolbar>
    </AppBar>
  );
};
